export default function splitFilename(filename: string) {
  const parts = filename.split('.');
  const extension = parts.length > 1 ? parts[parts.length - 1] : '';
  const baseName = parts.length > 1 ? parts.slice(0, parts.length - 1).join('.') : parts[0];
  return { extension, baseName };
}
